import { render, staticRenderFns } from "./SellerAnalysisAdvanced.vue?vue&type=template&id=3f20bad4"
import script from "./SellerAnalysisAdvanced.vue?vue&type=script&lang=js"
export * from "./SellerAnalysisAdvanced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports